import {
  $getBrands,
  $getModelsByBrandId,
  $getVehicleTypes,
  $getUserVehicles,
  $saveNewVehicle,
  $editVehicle,
  $deleteVehicle,
} from "@/utils/endpoints";
export const state = () => ({
  vehicles: null,
  vehicleTypes: null,
  selectedVehicleType: {},
  brands: [],
  selectedBrand: {},
  brandModels: [],
  selectedModel: {},
  isColorsAccordionOpen: false,
  selectedColor: null,
  licensePlate: "",
  hasSavedVehicle: false,
  colors: [
    "#0fa0de",
    "#f6d304",
    "#28a537",
    "#adadad",
    "#df4949",
    "#000000",
    "#ffffff",
  ],
  vehicleId: null,
  hasSuccessfullyEdited: false,
  hasEditedVehicle: false,
  hasSuccessfullyDeleted: false,
  isVehicleConfiguratorDisabled: false,
  isOldVehicle: false,
});

const getters = {
  vehicles: (state) => state.vehicles,
  vehicleTypes: (state) => state.vehicleTypes,
  selectedVehicleType: (state) => state.selectedVehicleType,
  brands: (state) => state.brands,
  selectedBrand: (state) => state.selectedBrand,
  brandModels: (state) => state.brandModels,
  selectedModel: (state) => state.selectedModel,
  isColorsAccordionOpen: (state) => state.isColorsAccordionOpen,
  selectedColor: (state) => state.selectedColor,
  licensePlate: (state) => state.licensePlate,
  hasSavedVehicle: (state) => state.hasSavedVehicle,
  isVehicleTypeScooter: (state) => {
    return (
      state.selectedVehicleType &&
      state.selectedVehicleType.customType === "Scooter"
    );
  },
  isVehicleTypeCar: (state) => {
    return (
      state.selectedVehicleType &&
      state.selectedVehicleType.customType === "Auto"
    );
  },
  colors: (state) => state.colors,
  vehicleId: (state) => state.vehicleId,
  hasEditedVehicle: (state) => state.hasEditedVehicle,
  hasSuccessfullyEdited: (state) => state.hasSuccessfullyEdited,
  hasSuccessfullyDeleted: (state) => state.hasSuccessfullyDeleted,
  isVehicleConfiguratorDisabled: (state) => state.isVehicleConfiguratorDisabled,
  isOldVehicle: (state) => state.isOldVehicle,
};
const mutations = {
  setVehicles: (state, value) => {
    //USED FOR DISPLAYING VEHICLES IN VEHICLE PICKER
    state.vehicles = value;
  },
  setVehicleTypes: (state, value) => {
    // USED FOR DISPLAYING USER'S VEHICLE TYPE
    state.vehicleTypes = value;
  },
  selectVehicleType: (state, newValue) => {
    state.selectedVehicleType = newValue;
    state.hasEditedVehicle = true;
  },
  setBrands(state, brands) {
    state.brands = brands;
  },
  selectBrand(state, brand) {
    state.selectedBrand = brand;
    state.selectedModel = {};
    state.hasEditedVehicle = true;
  },
  setBrandModels(state, brandModels) {
    state.brandModels = brandModels;
  },
  selectModel(state, model) {
    state.selectedModel = model;
    state.hasEditedVehicle = true;
  },
  toggleColorsAccordion(state) {
    state.isColorsAccordionOpen = !state.isColorsAccordionOpen;
  },
  selectColor(state, color) {
    state.selectedColor = color;
    state.isColorsAccordionOpen = false;
    state.hasEditedVehicle = true;
  },
  selectLicensePlate(state, plate = "") {
    state.licensePlate = plate.toUpperCase();
    state.hasEditedVehicle = true;
  },
  saveVehicle(state, value = true) {
    state.hasSavedVehicle = !!value;
  },
  setVehicleId(state, value) {
    state.vehicleId = value;
  },
  setHasEditedVehicle(state, value) {
    state.hasEditedVehicle = value;
  },
  editVehicle(state, value) {
    state.hasSuccessfullyEdited = value;
  },
  setHasDeletedVehicle(state, value) {
    state.hasSuccessfullyDeleted = value;
  },
  setIsVehicleConfiguratorDisabled(state, value) {
    state.isVehicleConfiguratorDisabled = value;
  },
  setIsOldVehicle(state, value) {
    state.isOldVehicle = value;
  },
  resetSelectedVehicle(state) {
    state.selectedVehicleType = {};
    state.selectedBrand = {};
    state.selectedModel = {};
    state.selectedColor = "";
    state.isColorsAccordionOpen = false;
    state.licensePlate = "";
    state.hasEditedVehicle = false;
  },
};

export const actions = {
  getVehicles: async ({ commit }, token) => {
    const res = await $getVehicleTypes(token);
    const customizedVehicles = res
      .map((v) => {
        const isCar = v.type.includes("Auto");
        return {
          ...v,
          customType: isCar ? "Auto" : "Scooter",
          car_id: isCar ? 2 : 1,
        };
      })
      .reduce((filteredVehicleTypes, current) => {
        return !filteredVehicleTypes.some((el) => {
          return el.customType === current.customType;
        })
          ? [...filteredVehicleTypes, current]
          : filteredVehicleTypes;
      }, []);
    commit("setVehicles", customizedVehicles);
    commit("setVehicleTypes", res);
  },
  getVehicleTypes: async ({ commit }, token) => {
    const res = await $getVehicleTypes(token);
    commit("setVehicleTypes", res);
  },
  getBrands: async ({ commit }) => {
    const brands = await $getBrands();
    commit("setBrands", brands);
  },
  resetVehicleConfigurations: ({ commit }) => {
    commit("selectBrand", {});
    commit("setBrandModels", []);
    commit("selectColor", null);
    commit("selectLicensePlate", "");
    commit("saveVehicle", false);
    commit("setIsVehicleConfiguratorDisabled", false);
  },
  getBrandModels: async ({ commit }, brandId) => {
    const brandModels = await $getModelsByBrandId(brandId);
    const formattedBrandModels = brandModels.models.map((modelObj) => ({
      ...modelObj,
      modelUppercase: modelObj.model.toUpperCase(),
    }));
    commit("setBrandModels", formattedBrandModels);
  },
  saveNewModel: async ({ commit }, { userId, model, token }) => {
    const resp = await $getUserVehicles(userId, token);
    const oldVehicle =
      resp &&
      resp.find(
        ({ active, number_plate }) =>
          active && number_plate === model.number_plate
      );
    commit("setIsOldVehicle", !!oldVehicle);
    if (oldVehicle) {
      commit("setVehicleId", oldVehicle.id);
    } else {
      const res = await $saveNewVehicle(userId, model, token);
      if (res && res.id) {
        commit("setVehicleId", res.id);
        commit("setHasEditedVehicle", false);
      }
    }
  },
  postEditVehicle: async ({ commit }, { userId, model, token }) => {
    const res = await $editVehicle(userId, model, token);
    if (res && res.id) {
      commit("editVehicle", true);
      commit("setHasEditedVehicle", false);
    } else {
      commit("editVehicle", false);
    }
  },
  postDeleteVehicle: async ({ commit }, { userId, model, token }) => {
    const res = await $deleteVehicle(
      userId,
      { ...model, active: false },
      token
    );
    if (res && res.id) {
      commit("setHasDeletedVehicle", true);
    } else {
      commit("setHasDeletedVehicle", false);
    }
  },
  setSelectedVehicle: async ({ commit, getters, dispatch }, vehicle) => {
    const vehicleBrand = getters.brands.find(
      ({ name }) => name.toLowerCase() === vehicle.brand.toLowerCase()
    );
    await dispatch("getBrandModels", vehicleBrand.id);
    const vehicleModel = getters.brandModels.find(
      ({ model }) => vehicle.model.toLowerCase() === model.toLowerCase()
    );
    if(!vehicleModel)  {
      const error = `Car model "${vehicle.model}" not found!`
      console.error(error);
      throw error;
    }
    commit(
      "selectVehicleType",
      getters.vehicles.find(({ id }) =>
        // 1 = Scooter
        // 2 = any car (Auto)
        vehicle.vehicle_type_id === 1
          ? id === vehicle.vehicle_type_id
          : id === 2
      )
    );
    commit("selectBrand", vehicleBrand);
    commit("selectModel", vehicleModel);
    commit("selectColor", vehicle.color);
    commit("selectLicensePlate", vehicle.number_plate);
    commit("setHasEditedVehicle", false);
    commit("setVehicleId", vehicle.id);
  },
};

const namespaced = true;

export default {
  state,
  mutations,
  getters,
  actions,
  namespaced,
};
